import { x } from '@xstyled/styled-components';
import React, { useEffect, useState } from 'react';
import { t } from 'ttag';
import { CloseButton } from '~/ui/buttons/CloseButton';
import { Card } from '~/ui/card/Card';
import { Flex } from '~/ui/flex/Flex';
import { Spinner } from '~/ui/spinner/Spinner';
import { HelpPages, useHelpStore } from '../Store';
import { FaqItem } from './FaqItem';
import { data } from './Faq-data';
import { useSequenceStore } from '~/training/sequence/SequenceStore';

export const Faq = () => {
  const { open, setPage } = useHelpStore();
  const [expanded, setExpanded] = useState<string>();
  const { addBlocker, removeBlocker } = useSequenceStore();

  useEffect(() => {
    addBlocker('nextBtn');
    return () => removeBlocker('nextBtn');
  }, [open]);

  return (
    <Flex variant="center" h="100%" p="md">
      <Card
        /* No top padding: sticky Back pins below the scrollport's padding,
           so any there shows scrolled text above the Back bar. */
        px={{ _: 'md', sm: 'xl' }}
        pb={{ _: 'md', sm: 'xl' }}
        w={{ _: '95%', sm: '660px' }}
        maxH="90vh"
        /* Both axes: overflow-y alone can leave corners unclipped at zoom. */
        overflow="auto"
      >
        <CloseButton sticky onClick={() => setPage(HelpPages.Root)} />
        <Flex variant="list" gap="md">
          <x.h2 id="help-faq-title">{t`Frequently asked questions`}</x.h2>
          {!data ? (
            <Spinner />
          ) : (
            data?.map(({ id, title, body }) => (
              <FaqItem
                key={id}
                title={title}
                expanded={id === expanded}
                onClick={() => setExpanded(!expanded ? id : undefined)}
              >
                <x.div dangerouslySetInnerHTML={{ __html: body }}></x.div>
              </FaqItem>
            ))
          )}
        </Flex>
      </Card>
    </Flex>
  );
};
